module.exports = __webpack_public_path__ + "img/finishChecked3.56ce4378.png";